import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpEvent, HttpEventType} from '@angular/common/http';
import { Router } from '@angular/router';
import { LoadingService } from '../loading/loading.service';
import { Observable } from 'rxjs/Rx';
import CONFIG from '../../config';
import { map } from "rxjs/operators";
import { catchError } from 'rxjs/operators';


@Injectable({
    providedIn: 'root'
})
export class AuthService {
    public loggedIn: boolean;
    public NIBNumber: String = localStorage.getItem('NIBNumber') || sessionStorage.getItem('NIBNumber');
    public token: string = localStorage.getItem('token') || sessionStorage.getItem('token');


    public LoginType: String = localStorage.getItem('LoginType') || sessionStorage.getItem('LoginType');
    
    constructor(
        private _http: HttpClient, 
        private _router: Router,
        private _loadingService: LoadingService)
    {

    }

    login(loginData): Observable<any> {
        //this._loadingService.show();
        const body = JSON.stringify(loginData);
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${this.token}`
            })
        };

        //console.log(body, httpOptions);

        return this._http.post(CONFIG.loginApiUrlBase, body, httpOptions)
            .pipe(
                catchError(this.handleError)
            );

    }
   
    // logout() {
    //     this._loadingService.show();
    //     this.loggedIn = false;
    //     this._http.get(CONFIG.loginApiUrlBase)
    //         .subscribe(response => {
    //             this._loadingService.hide();
    //             if (localStorage.getItem('token') !== null) {
    //                 localStorage.removeItem('NIBNumber');
    //                 localStorage.removeItem('token');
    //                 localStorage.removeItem('NIBNumber');
    //             }
    //             if (sessionStorage.getItem('token') !== null) {
    //                 localStorage.removeItem('NIBNumber');
    //                 sessionStorage.removeItem('token');
    //                 localStorage.removeItem('NIBNumber');
    //             }

    //             //remove locally cached identity variables
    //             this.token = null;
    //             this.loggedIn = false;
    //             this.NIBNumber = null;
    //             this._router.navigate(['/']);
    //         },
    //             error => {
    //                 this.handleError(error);
    //             },
    //             () => {
    //                 this._loadingService.hide();
    //             });
    // }

    logout() {
        this._loadingService.show();
        this.loggedIn = false;
        this._http.get(CONFIG.loginApiUrlBase)
            .subscribe(response => {
                this._loadingService.hide();
                if (localStorage.getItem('token') !== null) {
                    localStorage.removeItem('NIBNumber');
                    localStorage.removeItem('token');
                    localStorage.removeItem('NIBNumber');
                }
                if (sessionStorage.getItem('token') !== null) {
                    localStorage.removeItem('NIBNumber');
                    sessionStorage.removeItem('token');
                    localStorage.removeItem('NIBNumber');
                }
    
                // Clear cookies
                this.clearCookies();
    
                // Remove locally cached identity variables
                this.token = null;
                this.loggedIn = false;
                this.NIBNumber = null;
                this._router.navigate(['/']);
            },
            error => {
                this.handleError(error);
            },
            () => {
                this._loadingService.hide();
            });
    }
    
    clearCookies() {
        const cookies = document.cookie.split("; ");
        for (let cookie of cookies) {
            const eqPos = cookie.indexOf("=");
            const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;`;
        }
    }
    

    private handleError(error) {
        const errMsg = error.message || 'Server error';
        return Observable.throw(error);
    }
}